import { strictObjectAccess } from '@ackee/redux-utils';

export const forms = strictObjectAccess({
    createSupplier: 'createSupplier',
    updateSupplier: 'updateSupplier',
});

export const FILTER_DEBOUNCE_TIME = 500;
export const FILTER_DEFAULT_VALUE = '';
